import { PartnerAccountStatus, SubPartnerAccountStatus } from 'vopay';

/** The status an account or partner account reads as: an account's, a partner account's, or none. */
export type DerivedPartnerAccountStatus = PartnerAccountStatus | SubPartnerAccountStatus | null;

/**
 * The status an account — or a partner account, which shares the rule — is in, as the portal reads
 * it: Blocked overrides everything, an active one is Active, otherwise the onboarding status the
 * API reports (null for a partner account with no recorded stage). The status badge and anything
 * that gates on "is this account usable" must agree, so both read it from here.
 *
 * Takes the two fields by shape rather than by `AccountBalance` / `SubPartnerAccount`, so the
 * organization chart's rows (`OrganizationEntity`, which carries either kind's status) read by the
 * same rule.
 */
export default function derivePartnerAccountStatus(account: {
  AccountStatus: PartnerAccountStatus | SubPartnerAccountStatus | null;
  IsActive: boolean;
}): DerivedPartnerAccountStatus {
  if (account.AccountStatus === 'Blocked') return 'Blocked';

  return account.IsActive ? 'Active' : account.AccountStatus;
}
